import { idSchema } from "@stylingcv/schema";
import { dateSchema } from "@stylingcv/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const customJobTitleSchema = z.object({
  id: idSchema,
  title: z.string().min(1).max(255).trim(),
  userId: idSchema,
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export const createCustomJobTitleSchema = z.object({
  title: z.string().min(1).max(255).trim(),
});

export const updateCustomJobTitleSchema = z.object({
  title: z.string().min(1).max(255).trim(),
});

export class CustomJobTitleDto extends createZodDto(customJobTitleSchema) {}
export class CreateCustomJobTitleDto extends createZodDto(createCustomJobTitleSchema) {}
export class UpdateCustomJobTitleDto extends createZodDto(updateCustomJobTitleSchema) {}
